module.exports = __webpack_public_path__ + "static/media/howard_gardens-01.f7a5d5fc.png";